<script>
export default {
    name: 'design-2021-help-index-component',
    props: {
        userIn: {
            type: Object,
            required: true,
        },
    },
};
</script>

<template>
    <div class="help-wrapper">
        <design-2021-help-zoho-tutorials-component> </design-2021-help-zoho-tutorials-component>
        <div class="help-body">
            <div class="contact-form-and-info">
                <design-2021-help-contact-form-component :user-in="userIn"></design-2021-help-contact-form-component>
                <design-2021-help-contact-info-component></design-2021-help-contact-info-component>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.help-body {
    .embed-responsive {
        height: 300px;
        filter: grayscale(0.8);
        transition: filter 0.8s ease;
        margin-bottom: $grid-gutter-width;

        &:hover {
            filter: grayscale(0);
        }
    }

    .contact-form-and-info {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: auto;

        .contact-form-wrapper {
            grid-area: 1 / 1 / 2 / 2;
        }

        .contact-info-wrapper {
            grid-area: 2 / 1/ 3 / 2;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .help-body {
        .contact-form-and-info {
            grid-template-columns: 55% 45%;

            .contact-form-wrapper {
                grid-area: 1 / 1 / 2 / 2;
            }

            .contact-info-wrapper {
                grid-area: 1 / 2 / 2 / 3;
            }
        }
    }
}
</style>
